import { useState, useEffect } from "react";

const useMediaQuery = (query) => {
  const [matches, Setmatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    if (media.matches !== matches) {
      Setmatches(media.matches);
    }

    const actioner = () => Setmatches(media.matches);
    window.addEventListener("resize", actioner);
    return () => window.removeEventListener("resize", actioner);
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
